// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.editor-container {
    padding: 10px;
    max-width: 1000px;
    margin: auto;
}

div.DraftEditor-root {
    border: 1px solid #000;
    min-height: 200px;
    height: 500px;
    padding: 5px;
    overflow-y: auto;
    background-color: #FFF;
}

div.DraftEditor-editorContainer,
div.public-DraftEditor-content {
  height: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/MyEditor/MyEditor.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,sBAAsB;IACtB,iBAAiB;IACjB,aAAa;IACb,YAAY;IACZ,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;;EAEE,YAAY;AACd","sourcesContent":["div.editor-container {\n    padding: 10px;\n    max-width: 1000px;\n    margin: auto;\n}\n\ndiv.DraftEditor-root {\n    border: 1px solid #000;\n    min-height: 200px;\n    height: 500px;\n    padding: 5px;\n    overflow-y: auto;\n    background-color: #FFF;\n}\n\ndiv.DraftEditor-editorContainer,\ndiv.public-DraftEditor-content {\n  height: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
